// extracted by mini-css-extract-plugin
export default {"container":"_64566c66","header":"_8afb985e","paragraphText":"_e1351db2"};